/**
 * Dotdigital, shared by the `dotdigital-tag` and `dotdigital` destinations.
 *
 * A lettermark fallback rather than Dotdigital's real mark — their brand assets are not published
 * under terms this repo can vendor, and several shipped destinations use the same fallback. The
 * dot is the one distinguishing element of Dotdigital's own wordmark, so it is kept.
 */
export default (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="4" fill="#0B1B2B" />
    {/* lowercase "d" */}
    <path
      d="M13.7 6h1.8v11h-1.8v-1.05a3.4 3.4 0 0 1-2.6 1.2A3.8 3.8 0 0 1 7.3 13.2a3.8 3.8 0 0 1 3.8-3.95c1.05 0 1.95.42 2.6 1.18V6Zm-2.4 9.55a2.3 2.3 0 0 0 2.4-2.35 2.3 2.3 0 0 0-2.4-2.35 2.3 2.3 0 0 0-2.35 2.35 2.3 2.3 0 0 0 2.35 2.35Z"
      fill="white"
    />
    {/* the dot */}
    <circle cx="18" cy="15.9" r="1.35" fill="#3ED6B5" />
  </svg>
);
